import mutations from './mutations';
import actions from './actions';
import getters from "./getters";
import { ContactInfo } from "../interfaces/contactInfo";
import ContactRoom from "../interfaces/contactRoom";
import ContactPerson from "../interfaces/contactPerson";
import Driver from "../interfaces/driver";

export interface PersonalDataState {
    contactInfo: ContactInfo,
    rooms: ContactRoom[],
    persons: ContactPerson[],
    useContactInfo: number | null
    driver: Driver,
    defaultPersons: ContactPerson[]
}

export const initialState: PersonalDataState = {
    contactInfo: {
        salutation: '',
        firstname: '',
        lastname: '',
        street: '',
        zip: '',
        city: '',
        country: '',
        dialCode: '',
        phone: '',
        email: '',
        phoneWithDialCode: '',
        iso2: ''
    },
    rooms: [],
    persons: [],
    useContactInfo: null,
    driver: {
        driverCount: 0,
        isValid: true
    },
    defaultPersons: []
}

export default {
    namespaced: false,
    state: initialState,
    mutations,
    actions,
    getters
}
